import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';


const INPUT_FIELD_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => StatusComponent),
    multi: true
};

@Component({
    selector: 'status',
    templateUrl: './status.component.html',
    providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class StatusComponent implements ControlValueAccessor, OnInit {
    @Input() disabled: any;
    @Input() appearance = 'outline';

    public selectValue: FormControl = new FormControl(null, [Validators.required]);

    constructor(
        private fuseTranslationLoaderService: FuseTranslationLoaderService
        ) {
        this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
        this.selectValue.valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.onChange(value);
            });
    }

    ngOnInit(): void {
        if (this.disabled) { this.selectValue.disable(); }
    }

    onChange: (_: any) => void = () => {};
    onTouched: (_: any) => void = () => {};

    writeValue(status: any): void {
        this.selectValue.setValue(status);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

}
